import React from 'react';
import { FollowersIcon } from '../../svg/dashboard/FollowersIcon';
import { PointsIcon } from '../../svg/dashboard/PointsIcon';
import { ProfileViewsIcon } from '../../svg/dashboard/ProfileViewsIcon';
import { MessageIcon } from '../../svg/MessageIcon';
import { Stat } from './Stat';

type Props = {
    profileViews: number;
    messages: number;
    followers: number;
    points: number;
};

export const StatisticsCard: React.FC<Props> = ({ profileViews, messages, followers, points }) => {
    return (
        <div className="statistics-card dark-theme">
            <div className="title-container">
                <h2 className="title">Statistics</h2>
            </div>
            <div className="content">
                <Stat
                    icon={<ProfileViewsIcon className="views" />}
                    label={`Profile View${profileViews !== 1 ? 's' : ''}`}
                    value={profileViews.toLocaleString()}
                />
                <Stat
                    icon={<MessageIcon />}
                    label={`New Message${messages !== 1 ? 's' : ''}`}
                    value={messages.toLocaleString()}
                />
                <div className="separator" />
                <Stat
                    icon={<FollowersIcon />}
                    label={`Follower${followers !== 1 ? 's' : ''}`}
                    value={followers.toLocaleString()}
                />
                <Stat
                    icon={<PointsIcon className="points" />}
                    label={`Point${points !== 1 ? 's' : ''}`}
                    value={points.toLocaleString()}
                />
            </div>
        </div>
    );
};
